import { combineReducers, configureStore } from "@reduxjs/toolkit";
import confirmReducer from "../reducer/confirmSlice";
import alertReducer from "../reducer/alertSlice";
import companyReducer from "../reducer/companySlice";
import loadingReducer from "../reducer/pageLoadingSlice";
import areaOptionsReducer from "../reducer/areaOptionsSlice";
import loginReducer from "../reducer/loginSlice";
import locationReducer from "../reducer/locationSlice";
import storage from "redux-persist/lib/storage";
import persistReducer from "redux-persist/es/persistReducer";
import perPageReducer from "../reducer/perPageSlice";
import expireReducer from 'redux-persist-expire'

const reducers = combineReducers({
    login: loginReducer,
    confirm: confirmReducer,
    alert: alertReducer,
    companyInfo: companyReducer,
    loading: loadingReducer,
    location: locationReducer,
    areaOptions: areaOptionsReducer,
    perPageOptions: perPageReducer 
})

// const persistConfig = {
//     key: "root",
//     storage,
//     whitelist: ['login'],
//     transform: [
//         expireReducer('login', {
//             expireSeconds: 10,
//             autoExpire: true,
//             persistedAtKey: 'auth_exp',
//             expireState: []
//         })
//     ]
// }

// const persistedReducer = persistReducer(persistConfig, reducers);
export const store = configureStore({
    // reducer: persistedReducer,
    reducer: reducers,
})